module.exports = __webpack_public_path__ + "img/LOGOS-152x24.60067939.png";